// Module
var code = `<div class="block-ui-overlay"></div> <div class="block-ui-message-container"> <div class="block-ui-message"> <span class="block-ui-spinner"> <img src="/assets/img/spinning-circles.svg" alt="spinning-circles"> </span> {{ state.message }} </div> </div>`;
// Exports
module.exports = code;